import { useTheme } from 'foundations-theming-specialty/utils';
import { GlobalToolbarLink, ICON_NAMES } from '../../../components/GlobalToolbar/Components';
import useLocation from '../../../hooks/useLocation';
import strToRegExp from '../../../utils/strToRegExp';
import { getUserGuideUrl } from '../utils/getUserGuideUrl';
import { jsx as _jsx } from "react/jsx-runtime";
const userGuideActiveLinkStyles = theme => `
  background: ${theme.color['global-shell-fill-nav-item-hover']};
  svg {
    fill: ${theme.color['global-shell-icon-nav-item-hover']} !important;
  }
  .icon-text-key {
    color: ${theme.color['global-shell-text-nav-item-hover']} !important;
  }
`;
export const UserGuideButton = () => {
  const theme = useTheme();
  const {
    pathname
  } = useLocation();
  const {
    href: userGuideUrl,
    pathname: userGuidePathname
  } = getUserGuideUrl();
  const regExp = strToRegExp(`/^\\${userGuidePathname}(\\/.*)?$/i`);
  const isActive = regExp ? regExp.test(pathname) : false;
  return /*#__PURE__*/_jsx(GlobalToolbarLink, {
    id: "grow-guide-user-guide-button",
    iconName: ICON_NAMES.GROW_GUIDE,
    itemName: "User Guide",
    href: userGuideUrl,
    ariaLabelKey: "nav.icons.userGuide",
    iconTitleKey: "nav.icons.userGuide",
    additionalStyles: isActive ? userGuideActiveLinkStyles(theme) : undefined
  });
};